module.exports = __webpack_public_path__ + "static/assets/4029d50f5a640f1b421bcf89aa8e7c61.svg";